import React, { useState, useEffect } from 'react';
import { FaArrowCircleDown } from 'react-icons/fa'; // Import the arrow down icon

const slides = [
    {
        image: '/assets/virtualtour.jpg',
        text: 'Explore our vivid virtual tours.',
        subtext: 'Discover Africa\'s wonders from your screen.'
    },
    {
        image: '/assets/ghana.jpg',
        text: 'Experience the Vibrant Culture of Accra.',
        subtext: 'From bustling markets to serene beaches.'
    },
    {
        image: '/assets/forest.jpg',
        text: 'Discover the Mysteries of African nature.',
        subtext: 'From lush rainforests to vast savannahs.'
    },
    {
        image: '/assets/oculus.jpg',
        text: 'Step into the Future of Travel with VR.',
        subtext: 'Immersive experiences that transport you to Africa\'s wonders.'
    }
];

const HeroCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showScrollDownArrow, setShowScrollDownArrow] = useState(true);

    // Automatic slide change effect
    useEffect(() => {
        const slideInterval = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % slides.length);
        }, 7000); // Image visible for 7 seconds

        return () => clearInterval(slideInterval);
    }, []);

    // Effect to show/hide scroll-down arrow based on scroll position
    useEffect(() => {
        const handleScroll = () => {
            // Hide arrow if user has scrolled down more than 100px
            if (window.scrollY > 100) {
                setShowScrollDownArrow(false);
            } else {
                setShowScrollDownArrow(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    // Function to scroll down to the next section
    const scrollToContent = () => {
        // Scrolls down by the height of the viewport, effectively moving past the full-screen carousel
        // You might adjust this if your next section has a specific ID or ref
        window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
    };

    return (
        <div className="relative w-full h-screen mt-0 overflow-hidden">
            {/* Image Slides */}
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`absolute inset-0 w-full h-full transition-opacity duration-[2000ms] ease-in-out ${currentIndex === index ? 'opacity-100' : 'opacity-0'}`}
                >
                    <img src={slide.image} alt={slide.text} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-black/50"></div> {/* Dark overlay */}
                </div>
            ))}

            {/* Text Content */}
            <div className="absolute inset-0 flex flex-col justify-center items-start p-4 md:p-10 lg:p-40 text-white overflow-hidden">
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`absolute transition-all duration-1000 ease-in-out ${
                            currentIndex === index ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                        }`}
                    >
                        <h1 className="text-4xl md:text-6xl font-bold font-cormorant-upright">
                            {slide.text}
                        </h1>
                        <p className={`mt-4 text-lg md:text-xl font-light transition-all duration-1000 ease-in-out ${
                            currentIndex === index ? 'opacity-100 translate-y-0 delay-300' : 'opacity-0 translate-y-10'
                        }`}>
                            {slide.subtext}
                        </p>
                    </div>
                ))}
            </div>

            {/* Vertical Indicators */}
            <div className="absolute right-5 md:right-10 top-1/2 -translate-y-1/2 flex flex-col gap-4">
                {slides.map((_, index) => (
                    <button key={index} onClick={() => goToSlide(index)} className={`w-2 h-8 rounded-full transition-all duration-500 ${currentIndex === index ? 'bg-white' : 'bg-white/50 hover:bg-white/75'}`}></button>
                ))}
            </div>

            {/* Scroll Down Indicator */}
            {showScrollDownArrow && (
                <button
                    onClick={scrollToContent}
                    className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white text-4xl hover:text-green-600 animate-bounce focus:outline-none z-20 transition-opacity duration-300"
                    aria-label="Scroll down"
                >
                    <FaArrowCircleDown />
                </button>
            )}
        </div>
    );
};

export default HeroCarousel;